import { normalizeLyrics } from './schema';

export function parseBoothSongSheet(input) {
  if (typeof input !== 'string') throw new Error('Paste a Booth song sheet');
  const lines = input.replace(/\r\n?/g, '\n').split('\n');
  let cursor = 0;
  while (cursor < lines.length && !lines[cursor].trim()) cursor += 1;

  let title = '';
  // Two Booth formats: "Copy everything" (Title:/Style:/Cadence:/Lyrics: blocks) and the
  // .txt download (bare title, Style:, [Section] blocks, Flow notes:).
  if (cursor < lines.length && !/^(Style|Cadence|Lyrics|Flow notes):/i.test(lines[cursor])
      && !/^\[[^\]]+\]$/.test(lines[cursor].trim())) {
    title = lines[cursor].trim().replace(/^Title:\s*/i, '');
    cursor += 1;
  }

  let style = '';
  const sections = [];
  const cadence = [];
  let current = null;
  let inFlowNotes = false;

  for (; cursor < lines.length; cursor += 1) {
    const raw = lines[cursor];
    const line = raw.trim();
    if (!line) continue;
    if (/^Style:/i.test(line)) {
      style = line.replace(/^Style:\s*/i, '');
      continue;
    }
    if (/^(Flow notes|Cadence):\s*$/i.test(line)) {
      inFlowNotes = true;
      current = null;
      continue;
    }
    if (/^Lyrics:\s*$/i.test(line)) {
      inFlowNotes = false;
      continue;
    }
    const sectionMatch = line.match(/^\[([^\]]+)\]$/);
    if (sectionMatch) {
      inFlowNotes = false;
      current = { label: sectionMatch[1].trim(), lines: [] };
      sections.push(current);
      continue;
    }
    if (inFlowNotes) {
      const colon = line.indexOf(':');
      cadence.push({
        label: colon >= 0 ? line.slice(0, colon).trim() : '',
        note: colon >= 0 ? line.slice(colon + 1).trim() : line,
      });
    } else if (current) {
      current.lines.push({ text: line });
    }
  }

  return normalizeLyrics({ version: 1, title, style, cadence, sections });
}
